import { DataProvider } from "../helpers"

import { OpDBScript, OpDBScriptResult } from "../models/custom"


export class DataProviderScript {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public customScriptResult = (guid: string): JQueryPromise<OpDBScriptResult> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetCustomScriptResult', { scriptGuid: guid }, 'OpxGetCustomScriptResultResult')
            .then((response: OpDBScriptResult) => {
                return new OpDBScriptResult(response)
            })
    }

    public customScriptStart = (script: OpDBScript): JQueryPromise<string> => {
        return this.dataProvider.sendRequestWithSession('OpxCustomScriptStart', { customScript: script.toJSON() }, 'OpxCustomScriptStartResult')
    }

    public customScriptStop = (guid: string): JQueryPromise<void> => {
        return this.dataProvider.sendRequestWithSession('OpxCustomScriptStop', { scriptGuid: guid }, null)
    }

    public getCustomScripts = (): JQueryPromise<OpDBScript[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetAllCustomScript', {}, 'OpxGetAllCustomScriptResult')
            .then((response: OpDBScript[]) => {
                return response.map((element: OpDBScript) => new OpDBScript(element))
            })
    }

    // Public Methods End
}